import(/* webpackMode: "eager" */ "D:\\b\\baczonedz\\src\\app\\rooms\\page.tsx");
